import {
  Avatar,
  AvatarProps,
  ProfilePhoto,
  ProfilePhotoProps,
} from "@lazarentertainment/web-design-system/components/avatar"

import { useChannelContext } from "./ChannelContext"

export type UserAvatarImageProps = AvatarProps

/*
 * This component hooks up the design system's Avatar component to this app's state.
 */
export const UserAvatarImage = ({ ...props }: UserAvatarImageProps) => {
  const { user } = useChannelContext()

  return (
    <Avatar {...props}>
      {user.avatarUrl ? (
        <img
          src={user.avatarUrl}
          alt={user.displayName}
          draggable={false}
        />
      ) : undefined}
    </Avatar>
  )
}

export type UserProfilePhotoProps = ProfilePhotoProps

/*
 * This component hooks up the design system's ProfilePhoto component to this app's state.
 */
export const UserProfilePhoto = ({ ...props }: UserProfilePhotoProps) => {
  const { user, live, recordingId } = useChannelContext()
  const isChannelLive = live && !recordingId

  return (
    <ProfilePhoto
      borderVariant={isChannelLive ? "live" : "default"}
      {...props}
    >
      {user.avatarUrl ? (
        <img
          src={user.avatarUrl}
          alt={user.displayName}
          draggable={false}
        />
      ) : undefined}
    </ProfilePhoto>
  )
}
